import { types } from 'mobx-state-tree';
import { CartNewProductTypeType } from '../types/CartNewProductType';
import Price from './Price';

const CartNewProduct = types.model('CartNewProduct', {
  type: CartNewProductTypeType,
  quantity: types.number,
  name: types.maybeNull(types.string),
  stock_unit: types.maybeNull(types.string),
  manufacturer: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  price: types.maybeNull(Price),
  variations: types.maybeNull(types.array(types.string))
});

export default CartNewProduct;



// WEBPACK FOOTER //
// ./src/models/CartNewProduct.js